import * as React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import EventIcon from "@mui/icons-material/Event";
import MailLockIcon from "@mui/icons-material/MailLock";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import Avatars from "../Avatar/Avatar";
import Logo from "../Avatar/Logo";

const items = [
  {
    icon: <AppRegistrationIcon sx={{ color: "text.secondary" }} />,
    title: "Registro",
    description:
      "Para proceder con el registro, por favor ingrese su número de documento. Asegúrese de incluir la inicial 'V', 'E' o 'P' correspondiente a su tipo de documento.",
  },
  {
    icon: <MailLockIcon sx={{ color: "text.secondary" }} />,
    title: "Código OTP",
    description:
      "Para verificar su dirección de correo electrónico, recibirá un código de 6 dígitos. Por favor, ingrese ese código para completar el proceso de inicio de sesión. Recuerde que deberá conservarlo para sus proximos ingreso.",
  },
  {
    icon: <FactCheckIcon sx={{ color: "text.secondary" }} />,
    title: "Verificación de datos",
    description:
      "Para agendar su cita deberá tomarse un momento y completar el siguiente formulario con sus datos personales. Debe tomar en cuenta que el correo electrónico debe ser único por cada cliente. Esto nos permite asegurar una comunicación directa y personalizada con cada uno de nuestros usuarios.",
  },
  {
    icon: <EventIcon sx={{ color: "text.secondary" }} />,
    title: "Solicitud de cita",
    description:
      "Luego de completar los pasos anteriores, podrá agendar su cita.",
  },
];

export default function Content() {
  return (
    <Stack
      sx={{
        flexDirection: "column",
        alignSelf: "center",
        gap: 4,
        maxWidth: 450,
       
      }}
    >
      <Box sx={{ display: { xs: "none", md: "flex" } }}>
     
        <Logo />
        
      </Box>
      {items.map((item, index) => (
        <Stack key={index} direction="row" sx={{ gap: 2 }}>
          {item.icon}
          <div>
            <Typography gutterBottom sx={{ fontWeight: "medium" }}>
              {item.title}
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              {item.description}
            </Typography>
          </div>
        </Stack>
      ))}
    </Stack>
  );
}
